import script from "./PaginationComp.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationComp.vue?vue&type=script&setup=true&lang=js"

import "./PaginationComp.vue?vue&type=style&index=0&id=59212484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59212484"]])

export default __exports__